// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";
import { Branche } from "../../../common/interfaces/conversionworld/Branche";
import { ImageAspectRatio } from "../../image_aspect_ratio/ImageAspectRatio";
import { PopularSolutionLink } from "../../../common/interfaces/conversionworld/PopularSolution";

@Component({
  mixins: [template],
  components: {
    ImageAspectRatio,
  },
})
export class BranchenDetail extends Vue {
  @Prop()
  public branche!: Branche;

  @Prop({ default: () => [] })
  public popularSolution!: Array<PopularSolutionLink>;
}
